module.exports = __webpack_public_path__ + "img/success_icon.c746c552.png";